import React from 'react';
import PropTypes from 'prop-types';
import { compose, defaultProps, withHandlers } from 'recompose';

import { SelectBox } from 'components/core/SelectBox';


export function SortBySelectBox({ options, value, handleChange }) {
	return (
		<SelectBox
			id="sort-by"
			label="Sort By"
			onChange={handleChange}
			options={options}
			value={value}
			key={value}
		/>
	);
}

export const enhance = compose(
	defaultProps({
		onChange: () => {}
	}),
	withHandlers({
		handleChange: (props) => (event) => {
			props.onChange({ order: event.target.value });
		}
	})
);

SortBySelectBox.defaultProps = {
	options: [{
		value: 'recommended',
		display: 'Recommended'
	}, {
		value: 'star_rating_sf',
		display: 'Reviews'
	}, {
		value: 'price',
		display: 'Price'
	}, {
		value: 'distance',
		display: 'Distance'
	}],
	value: 'recommended'
};

SortBySelectBox.propTypes = {
	options: PropTypes.arrayOf(PropTypes.shape({
		value: PropTypes.any,
		display: PropTypes.any
	})),
	value: PropTypes.string,
	handleChange: PropTypes.func
};

export default enhance(SortBySelectBox);
